import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import {
  IncidentScoreConfig,
  IncidentsResultConfiguration,
  ScoreConfig,
} from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/IncidentsResultConfiguration'

/**
 * Details Panel only. Result-configuration part of deletability. Incidents
 * adding points to either team - directly or through one of their attributes -
 * are blocked here. Matching `ScoreConfig`s can override that default with
 * `isDeletable`. Callers must still combine this with `isIncidentDeletable`.
 */
export function isIncidentDeletableByResultConfiguration(
  incident: ProbableIncident,
  configuration: IncidentsResultConfiguration,
): boolean {
  return getMatchingScoreConfigs(incident, configuration).every(
    (scoreConfig) => scoreConfig.isDeletable ?? !changesResult(scoreConfig),
  )
}

function changesResult(scoreConfig: ScoreConfig): boolean {
  return scoreConfig.add !== undefined
}

function getMatchingScoreConfigs(
  incident: ProbableIncident,
  configuration: IncidentsResultConfiguration,
): ScoreConfig[] {
  const { scoringIncidents, oppositeTeamScoringIncidents } = configuration
  const incidentConfigs = [
    scoringIncidents.get(incident.incident_id),
    oppositeTeamScoringIncidents?.get(incident.incident_id),
  ].filter((config): config is IncidentScoreConfig => !!config)

  const attributeIds = incident.attribute_ids ?? []

  return incidentConfigs.flatMap((incidentConfig) => [
    incidentConfig,
    ...attributeIds.flatMap((attributeId) => {
      const attributeConfig = incidentConfig.attributes?.get(attributeId)

      return attributeConfig ? [attributeConfig] : []
    }),
  ])
}
